// src/components/AdminRoute.jsx
import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";

export default function AdminRoute({ children }) {
  const { user, authLoading } = useContext(UserContext);
  console.log("user", user);

  if (authLoading) {
    return (
      <div style={{ minHeight: "100vh", background: "#0a0d12", color: "#fff", display: "grid", placeItems: "center" }}>
        Checking admin access...
      </div>
    );
  }

  // ⛔ If user not logged in
  if (!user) {
    return <Navigate to="/" replace />;
  }

  // ⛔ If user is not an admin
  if (user.role !== "admin") {
    return <Navigate to="/" replace />;
  }

  // ✅ If user is admin
  return children;
}
